import { Td, Tr, Typography } from '@aloft/toolkit-sui';

type Props = {
  data: {
    label: string;
    value: (string | null)[];
  };
};

export function ManufacturedCostApproachTableSectionRow(props: Props) {
  const {
    data: { label, value },
  } = props;
  return (
    <Tr>
      <Td>
        <Typography variant="body1">{label}</Typography>
      </Td>
      <Td colSpan={3}>
        <Typography variant="body1">{value[0] ?? ''}</Typography>
      </Td>
      <Td colSpan={3}>
        <Typography variant="body1">{value[1] ?? ''}</Typography>
      </Td>
      <Td className="cost-approach-table-align-right">
        <Typography variant="body1">{value[2] ?? ''}</Typography>
      </Td>
    </Tr>
  );
}
